<section class="lp-countries-hero-jumbotron">
  <div class="row">
    <div class="col-12">
      <div class="lp-countries-hero-wrapper">
        <div class="lp-countries-hero-left">
          <h1>
            Get Access to Global Brands with Fast Shipping to
            <span class="highlight" *ngIf="activeCountry.country_code === 'US' || activeCountry.country_code === 'UK'" >the {{activeCountry.country_code}}</span> 
            <span class="highlight" *ngIf="activeCountry.country_code !== 'US' && activeCountry.country_code !== 'UK'" >{{activeCountry.country_name}}</span>,
          </h1>

          <h3>
            Frustrated by "we don't ship to <span class="highlight" *ngIf="activeCountry.country_code === 'US' || activeCountry.country_code === 'UK'" >the {{activeCountry.country_code}}</span> 
            <span class="highlight" *ngIf="activeCountry.country_code !== 'US' && activeCountry.country_code !== 'UK'" >{{activeCountry.country_name}}</span>" messages? Tired of missing out on international sales and exclusive products? Shippn gives you <strong>unlimited access to shop from ANY country</strong> and ship directly to your doorstep in <span class="highlight" *ngIf="activeCountry.country_code === 'US' || activeCountry.country_code === 'UK'" >the {{activeCountry.country_code}}</span> 
            <span class="highlight" *ngIf="activeCountry.country_code !== 'US' && activeCountry.country_code !== 'UK'" >{{activeCountry.country_name}}</span>!
          </h3>

          <div class="lp-countries-hero-cta-wrapper">
            <button class="lp-countries-hero-cta-btn" [routerLink]="['/',lang,'signup']" aria-label="Sign Up For Free">
              Sign Up For Free
            </button>
            <button class="lp-countries-hero-cta-btn video-btn" (click)="openYTVideoDialog()" aria-label="See The Video">
             <span>&#9654;</span>  See The Video
            </button>
          </div>
        </div>
        <div class="lp-countries-hero-right">
          <img [src]="fromCountryDetail.country_banner" alt="How to shop from United States Of America Banner" />
        </div>
      </div>
    </div>
  </div>
</section>